import { useSelector } from 'react-redux';
import { getTotalPriceUserPreference, TotalPriceSessionPreference, } from 'utils/total-price-session-utils';
export const useShowTotal = () => {
    const userPreferenceFromSession = getTotalPriceUserPreference();
    const reduxShowTotal = Boolean(useSelector((state) => state.filters.showTotal));
    const sessionShowTotal = userPreferenceFromSession === TotalPriceSessionPreference.On;
    return sessionShowTotal || reduxShowTotal;
};
